import { Controller } from 'stimulus'

export default class ContentLoaderController extends Controller {
  connect() {
    if (this.triggeredOnAction) {
      this.element.addEventListener(this.triggeredOnAction, (e) => {
        e.preventDefault()
        this.fetch()
      })
    } else {
      this.fetch()
    }
  }

  fetch(): void {
    fetch(this.urlValue)
      .then((response) => response.text())
      .then(this.injectHTML.bind(this))
  }

  injectHTML(html: string): void {
    switch (this.injectAt) {
      case 'prepend':
        this.injectTarget.insertAdjacentHTML('afterbegin', html)
        break
      case 'append':
        this.injectTarget.insertAdjacentHTML('beforeend', html)
        break
      case 'replace':
        this.injectTarget.innerHTML = html
        break
      default:
        this.injectTarget.insertAdjacentHTML('beforeend', html)
    }
  }

  get injectAt(): string {
    return (
      (this.element as HTMLElement).dataset.contentLoaderInjectAt || 'replace'
    )
  }

  get urlValue(): string {
    return (this.element as HTMLElement).dataset.contentLoaderUrl
  }

  get triggeredOnAction(): string | null {
    return (this.element as HTMLElement).dataset.contentLoaderAction
  }

  get injectTarget(): HTMLElement | null {
    return (
      document.querySelector(this.injectTargetSelector) ||
      (this.element as HTMLElement)
    )
  }

  get injectTargetSelector(): string | null {
    return (this.element as HTMLElement).dataset.contentLoaderTarget
  }
}
